<form
  #formRef="ngForm"
  (ngSubmit)="onSubmit()"
>
  @if (tabs.length > 0) {
  <p-tabs [(value)]="activeTabId">
    <p-tablist>
      @for (tab of tabs; track tab.id) {
      <p-tab [value]="tab.id">{{ tab.label }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      @for (tab of tabs; track tab.id) {
      <p-tabpanel [value]="tab.id">
        <div class="row">
          @for (field of getFieldsForTab(tab.id); track field.fieldName) {
          <div
            class="form-group mb-3"
            [ngClass]="field.options?.widthClass ?? 'col-12'"
          >
            <ng-container
              [ngTemplateOutlet]="fieldTpl"
              [ngTemplateOutletContext]="{ field: field }"
            ></ng-container>
          </div>
          }
        </div>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
  } @else {
  <div class="row">
    @for (field of formFields; track field.fieldName) {
    <div
      class="form-group mb-3"
      [ngClass]="field.options?.widthClass ?? 'col-12'"
    >
      <ng-container
        [ngTemplateOutlet]="fieldTpl"
        [ngTemplateOutletContext]="{ field: field }"
      ></ng-container>
    </div>
    }
  </div>
  }
  <div
    class="text-end mt-3"
    *ngIf="showActions"
  >
    @if (type === 'edit' && !hideDeleteButton) {
    <button
      type="button"
      pButton
      severity="danger"
      [outlined]="true"
      class="me-2"
      i18n="@@delete"
      (click)="onDelete()"
    >Löschen</button>
    }
    <button
      type="submit"
      pButton
      [disabled]="formRef.invalid || saving"
      [loading]="saving"
      i18n="@@save"
    >Speichern</button>
  </div>
</form>

<!-- Rendert genau ein Feld anhand seines Typs — von beiden Layout-Zweigen oben (mit/ohne Tabs)
     per ngTemplateOutlet wiederverwendet, damit die Feld-Logik nicht dupliziert werden muss. -->
<ng-template
  #fieldTpl
  let-field="field"
>
  @switch (field.type) {
  @case ('text') {
  <label
    class="form-label"
    [for]="field.fieldName"
  >{{ getLabel(field) }}</label>
  @if (field.required) {
  <span class="text-danger">*</span>
  }
  @if (field.fieldName === 'email' || field.fieldName.endsWith('.email')) {
  <app-test-user-badge [email]="getValue(field)"></app-test-user-badge>
  }
  <input
    [id]="field.fieldName"
    [name]="field.fieldName"
    type="text"
    class="form-control"
    [ngModel]="getValue(field)"
    (ngModelChange)="setValue(field, $event)"
    [required]="!!field.required"
    [readonly]="!!field.readonly"
  >
  }
  @case ('switch') {
  <div class="form-check form-switch">
    <input
      [id]="field.fieldName"
      [name]="field.fieldName"
      type="checkbox"
      role="switch"
      class="form-check-input"
      [ngModel]="getValue(field)"
      (ngModelChange)="setValue(field, $event)"
    >
    <label
      class="form-check-label"
      [for]="field.fieldName"
    >{{ getLabel(field) }}</label>
  </div>
  }
  @case ('select') {
  <label
    class="form-label"
    [for]="field.fieldName"
  >{{ getLabel(field) }}</label>
  @if (field.required) {
  <span class="text-danger">*</span>
  }
  <ng-select
    [id]="field.fieldName"
    [name]="field.fieldName"
    [items]="field.options?.selectValues ?? []"
    [bindLabel]="field.options?.bindLabel ?? ''"
    [bindValue]="field.options?.bindValue ?? ''"
    [ngModel]="getValue(field)"
    (ngModelChange)="setValue(field, $event)"
    [required]="!!field.required"
  >
    @if (field.options?.optionTemplate) {
    <ng-template
      ng-option-tmp
      let-item="item"
    >
      <ng-container
        [ngTemplateOutlet]="field.options.optionTemplate"
        [ngTemplateOutletContext]="{ item: item, data: data }"
      ></ng-container>
    </ng-template>
    }
    @if (field.options?.labelTemplate) {
    <ng-template
      ng-label-tmp
      let-item="item"
    >
      <ng-container
        [ngTemplateOutlet]="field.options.labelTemplate"
        [ngTemplateOutletContext]="{ item: item, data: data }"
      ></ng-container>
    </ng-template>
    }
  </ng-select>
  }
  @case ('multiselect') {
  <label
    class="form-label"
    [for]="field.fieldName"
  >{{ getLabel(field) }}</label>
  @if (field.required) {
  <span class="text-danger">*</span>
  }
  <ng-select
    [id]="field.fieldName"
    [name]="field.fieldName"
    [items]="field.options?.selectValues ?? []"
    [bindLabel]="field.options?.bindLabel ?? ''"
    [bindValue]="field.options?.bindValue ?? ''"
    [multiple]="true"
    [ngModel]="getValue(field)"
    (ngModelChange)="setValue(field, $event)"
    [required]="!!field.required"
  >
    @if (field.options?.optionTemplate) {
    <ng-template
      ng-option-tmp
      let-item="item"
    >
      <ng-container
        [ngTemplateOutlet]="field.options.optionTemplate"
        [ngTemplateOutletContext]="{ item: item, data: data }"
      ></ng-container>
    </ng-template>
    }
    @if (field.options?.labelTemplate) {
    <ng-template
      ng-label-tmp
      let-item="item"
    >
      <ng-container
        [ngTemplateOutlet]="field.options.labelTemplate"
        [ngTemplateOutletContext]="{ item: item, data: data }"
      ></ng-container>
    </ng-template>
    }
  </ng-select>
  }
  @case ('picklist') {
  <label class="form-label d-block">{{ getLabel(field) }}</label>
  @if (field.required) {
  <span class="text-danger">*</span>
  }
  <p-picklist
    [source]="getPicklistSource(field)"
    [target]="getPicklistTarget(field)"
    [targetOptionDisabled]="field.options?.readonlyTargetValues ? 'readonlyAssignment' : undefined"
    (onMoveToTarget)="syncPicklistValue(field)"
    (onMoveToSource)="syncPicklistValue(field)"
    (onMoveAllToTarget)="syncPicklistValue(field)"
    (onMoveAllToSource)="syncPicklistValue(field)"
    [dataKey]="field.options?.bindValue"
    [sourceHeader]="field.options?.sourceHeader"
    [targetHeader]="field.options?.targetHeader"
    [showSourceControls]="false"
    [showTargetControls]="false"
    [responsive]="true"
  >
    <ng-template
      #item
      let-item
    >
      <div [class.opacity-50]="isReadonlyPicklistItem(field, item)">
        @if (field.options?.optionTemplate) {
        <ng-container
          [ngTemplateOutlet]="field.options.optionTemplate"
          [ngTemplateOutletContext]="{ item: item, data: data }"
        ></ng-container>
        } @else {
        {{ getPicklistItemLabel(field, item) }}
        }
        @if (isReadonlyPicklistItem(field, item)) {
        <small i18n="@@userTileSharedReadonly">Für alle freigegeben</small>
        }
      </div>
    </ng-template>
  </p-picklist>
  }
  @case ('template') {
  <ng-container
    [ngTemplateOutlet]="field.options?.template"
    [ngTemplateOutletContext]="{ data: data }"
  ></ng-container>
  }
  }
</ng-template>